(() => {
  "use strict";
  if (window.__faithNavigationLoaded) return;
  window.__faithNavigationLoaded = true;

  const current = new URL(window.location.href);
  const storeHosts = new Set([current.hostname, "faiththroughthis.com", "www.faiththroughthis.com"]);
  for (const domain of (document.body.dataset.faithStoreDomains || "").split(/\s+/)) {
    if (!domain) continue;
    try { storeHosts.add(new URL(`https://${domain}`).hostname); } catch { /* Ignore empty/invalid metadata. */ }
  }
  const candidate = current.searchParams.get("preview_theme_id") || document.body.dataset.faithThemeId || "";
  const previewId = /^\d+$/.test(candidate) ? candidate : "";
  const root = document.body.dataset.faithRoot || "/";
  const routes = {
    "/shop": "/collections/all",
    "/guided-prayers": "/pages/guided-prayers",
    "/prayers": "/pages/guided-prayers",
    "/daily-scripture": "/pages/daily-scripture",
    "/scripture": "/pages/daily-scripture",
    "/prayer-library": "/pages/prayer-library",
    "/get-encouragement": "/pages/prayer-library",
    "/encouragement": "/pages/prayer-library",
    "/steady-steps": "/pages/steady-steps",
    "/about": "/pages/about",
    "/contact": "/pages/contact",
    "/privacy": "/pages/privacy",
    "/terms": "/pages/terms",
    "/blog": "/blogs/news",
  };
  // Theme ZIPs cannot create Shopify Page records. These features are included
  // on the homepage, so navigation works immediately after a theme upload.
  const features = {
    "/guided-prayers": "prayers", "/prayers": "prayers",
    "/pages/guided-prayers": "prayers", "/pages/prayers": "prayers",
    "/daily-scripture": "scripture", "/scripture": "scripture",
    "/pages/daily-scripture": "scripture", "/pages/scripture": "scripture",
    "/scripture-library": "scripture", "/pages/scripture-library": "scripture",
    "/prayer-library": "prayer-library", "/pages/prayer-library": "prayer-library",
    "/get-encouragement": "encouragement", "/encouragement": "encouragement",
    "/pages/encouragement": "encouragement",
    "/steady-steps": "free-guide", "/pages/steady-steps": "free-guide",
    "/free-resources": "free-guide", "/pages/free-resources": "free-guide",
    "/free-guide": "free-guide", "/pages/free-guide": "free-guide",
    "/about": "our-story", "/pages/about": "our-story",
    "/our-story": "our-story", "/pages/our-story": "our-story",
    "/contact": "contact", "/pages/contact": "contact",
    "/blog": "journal", "/blogs/news": "journal", "/blogs/journal": "journal",
  };
  // Older previews/bookmarks may already be on a Page URL that Shopify has
  // never created. Recover only recognized feature routes, not arbitrary 404s.
  if (document.body.dataset.faithTemplate === "404") {
    const feature = features[current.pathname.replace(/\/+$/, "")];
    if (feature) {
      const destination = new URL(root, current.origin);
      destination.search = current.search;
      if (previewId) destination.searchParams.set("preview_theme_id", previewId);
      destination.hash = feature;
      window.location.replace(`${destination.pathname}${destination.search}${destination.hash}`);
      return;
    }
  }

  const normalize = (link) => {
    const href = link.getAttribute("href");
    if (!href || href.startsWith("#") || link.hasAttribute("download")) return;
    let destination;
    try { destination = new URL(href, current.href); } catch { return; }
    if (!["http:", "https:"].includes(destination.protocol) || !storeHosts.has(destination.hostname)) return;
    const path = destination.pathname.replace(/\/+$/, "") || "/";
    const feature = features[path] || (path.startsWith("/encouragement/") ? "prayers" : "");
    destination.pathname = feature ? root : path === "/" ? root : routes[path] || destination.pathname;
    if (feature) destination.hash = feature;
    if (previewId && !path.startsWith("/cdn/")) destination.searchParams.set("preview_theme_id", previewId);
    // Root-relative URLs use the store currently being previewed, not its
    // custom primary domain or the old reference website.
    link.setAttribute("href", `${destination.pathname}${destination.search}${destination.hash}`);
  };
  const scan = (rootNode) => {
    if (rootNode.matches?.("a[href]")) normalize(rootNode);
    rootNode.querySelectorAll("a[href]").forEach(normalize);
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scan(document), { once: true });
  } else {
    scan(document);
  }
  document.addEventListener("shopify:section:load", (event) => scan(event.target));
  document.addEventListener("click", (event) => {
    const link = event.target.closest?.("a[href]");
    if (link) normalize(link);
  }, true);
})();
